<template>
  <RouterView />
</template>

<script>
// import { startWS, leaveWS } from '@/plugins/websockets'

export default {
  name: 'CSEditorLayout',

  metaInfo() {
    return {
      bodyAttrs: {
        class: 'editor',
      },
    }
  },

  mounted() {
    // const user_ID = this.$store.state.user.id
    // // init websockets
    // if (user_ID) {
    //   startWS(user_ID)
    // }
  },

  beforeDestroy() {
    // const user_ID = this.$store.state.user.id
    // leaveWS(user_ID)
  },
}
</script>

<style lang="scss">
@import '@/assets/fonts/ibm-plex-sans.scss';
</style>
